<div class="wrap">
    <fa-icon class="close" [icon]="getFaIcon('faTimesCircle')" (click)="close()"></fa-icon>
    <h5>Liste de mes envies</h5>
    <ul class="basket">
        <ng-container *ngFor="let o of myShoppingBag, let i = index">
            <li>
                <div class="number">1x</div>
                <div class="name"> {{o.offerName}}</div>
            </li>
        </ng-container>
    </ul>
    <span class="my_basket" *ngIf="myShoppingBag.length" [routerLink]="['/home/my-shopping-bag']"
        routerLinkActive="router-link-active">
        <!-- Vous avez <strong>{{myShoppingBag.length}}</strong>
        {{myShoppingBag.length > 1 ? 'articles' : 'article' }} -->
        Voir mon panier
    </span>
    <div class="no_items" *ngIf="!myShoppingBag.length">Aucune expérience selectionnée</div>
</div>